/** Phân quyền — cài đặt */
export const SETTINGS_PERMISSION_CODES = {
  WEB_BH_SETTINGS_LIST: 'WEB_BH_SETTINGS_LIST',
  WEB_BH_SETTINGS_EDIT: 'WEB_BH_SETTINGS_EDIT',
  WEB_BH_SETTINGS_SAO_CHEP: 'WEB_BH_SETTINGS_SAO_CHEP',
} as const

export type SettingsPermissionCode =
  (typeof SETTINGS_PERMISSION_CODES)[keyof typeof SETTINGS_PERMISSION_CODES]

export const settingsPermissionCodeValues = Object.values(SETTINGS_PERMISSION_CODES)

export const SETTINGS_READ_PERMISSIONS = [
  SETTINGS_PERMISSION_CODES.WEB_BH_SETTINGS_LIST,
] as const

export const SETTINGS_MUTATE_PERMISSIONS = [
  SETTINGS_PERMISSION_CODES.WEB_BH_SETTINGS_EDIT,
  SETTINGS_PERMISSION_CODES.WEB_BH_SETTINGS_SAO_CHEP,
] as const
